import {
  Checkbox,
  CircularProgress,
  Divider,
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
  useMediaQuery,
  Paper
} from '@mui/material'
import { useTheme } from '@mui/material/styles'
import React, { useEffect, useState } from 'react'
import { TextBold, TextRegular } from '../../commonComponents/TextStyling'
import AppButton from '../../commonComponents/AppButton'
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined'
import serverData from '../../api/ServerData'
import { showToast } from '../../utils/AppHelper'
import { useDispatch } from 'react-redux'
import { logoutUser } from '../../actions/loginActions'
import { useNavigate } from 'react-router-dom'
import { ENV } from '../../ENV'

export default function EditPreferences () {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))
  const [loading, setLoading] = useState(true)
  const [loadingBtn, setLoadingBtn] = useState(false)
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [formError, setFormError] = useState({})

  const [preferences, setPreferences] = useState([])

  useEffect(() => {
    getEmailPreferences()
  }, [])

  function getEmailPreferences () {
    serverData.getEmailPreferences(
      {},
      result => {
        if (result.status) {
          let { response } = result
          setPreferences(response)
        }
        setLoading(false)
      },
      error => {
        setLoading(false)
        if (error.status === 401) {
          dispatch(logoutUser(navigate)) // eslint-disable-next-line
        }
      }
    )
  }

  const handleUpdate = () => {
    setLoadingBtn(true)

    var body = {}
    preferences.map(item => {
      body[item.keyname] = item.isChecked
    })

    serverData.updateEmailPreferences(
      body,
      result => {
        if (result.status) {
          showToast(result.message, false)
        } else {
          showToast(result.message)
        }
        setLoadingBtn(false)
      },
      error => {
        setLoadingBtn(false)
        if (error.status == 401) {
          dispatch(logoutUser(navigate)) // eslint-disable-next-line
        }
      }
    )
  }

  return (
    <Paper
      style={{
        padding: 24,
        borderRadius: 16
      }}
    >
      {loading ? (
        <Grid
          container
          spacing={2}
          direction={'column'}
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '70vh',
            width: '100%'
          }}
        >
          <Grid item>
            <CircularProgress />
          </Grid>
        </Grid>
      ) : (
        <Grid container direction={isMobile ? 'column-reverse' : 'row'}>
          <Grid item md={8} xs={12}>
            <Grid item xs={12} style={{textAlign:isMobile? 'center':'normal',marginTop:isMobile? '27px':'0px'}}>
              <TextBold style={{ fontSize: '16px'}}>
                Please select the types of emails you would like to receive from{' '}
                {ENV.product_name}:
              </TextBold>
            </Grid>
            <Grid item xs={12} style={{ marginTop: 24 }}>
              <FormGroup>
                {preferences.map((item, index) => (
                  <FormControlLabel
                    control={<Checkbox checked={item.isChecked} />}
                    label={item.label}
                    onChange={() => {
                      var data = [...preferences]
                      data[index].isChecked = !data[index].isChecked
                      setPreferences(data)
                    }}
                  />
                ))}
              </FormGroup>
            </Grid>
            <Grid item xs={12} style={{ marginTop: 24 }}>
              <TextBold>NOTE: </TextBold>
              <TextRegular
                style={{
                  color: theme.palette.text.secondary,
                  fontSize: '16px'
                }}
              >
                Your email preferences will not affect notifications for any
                candidate or job related updates.
              </TextRegular>
            </Grid>
            <Grid item xs={12} style={{ marginTop: 24 }}>
              <AppButton
                loading={loadingBtn}
                name={'Update'}
                onClick={() => handleUpdate()}
                fullWidth={false}
                style={{
                  padding: '12px 27px'
                }}
              />
            </Grid>
          </Grid>
          <Grid item md={0.1}  xs={12}>
            <Divider orientation='vertical' />
          </Grid>
          <Grid item md={3.9}  xs={12} textAlign={'center'}>
            <Grid item xs={12}>
              <EmailOutlinedIcon
                style={{
                  fontSize: '6rem',
                  color: theme.palette.text.secondary
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <TextBold style={{ fontSize: '16px' }}>
                Email preferences
              </TextBold>
            </Grid>
            <Grid item xs={12}>
              <TextRegular style={{ fontSize: '16px' }}>
                Let us know your email preferences
              </TextRegular>
            </Grid>
          </Grid>
        </Grid>
      )}
    </Paper>
  )
}
